import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {Schema} from "@/common/Schema";
import {Cloneable} from "@/common/Cloneable";

export class ExplainerPageImageModel extends Cloneable {

    constructor() {

        super();

        this._id = "";
        this._custom_message = null;
        this._highlighted = false;

    }

    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }

    get custom_message() {
        return this._custom_message;
    }
    set custom_message(value) {
        this._custom_message = value;
    }

    get highlighted() {
        return this._highlighted;
    }
    set highlighted(value) {
        this._highlighted = value;
    }

    copy() {
        return super.copy();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ExplainerPageImageModel());
        } else if (target instanceof ExplainerPageImageModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }

    static schema() {
        return custom((v) => {
            return v ? serialize(ExplainerPageImageModel, v) : SKIP;
        }, (v) => {
            return deserialize(ExplainerPageImageModel, v);
        });
    }
}

createModelSchema(ExplainerPageImageModel, {
    _id: alias("id", Schema.primitive()),
    _custom_message: alias("custom_message", Schema.primitive()),
    _highlighted: alias("highlighted", Schema.primitive()),
});